import { useStrictLocalization } from "@faire/web--source/common/localization";

import { useDisplayedOrderNumber } from "./useDisplayedOrderNumber";
import { useIssueType } from "./useIssueType";

export const useIssuePlaceholder = (): string => {
  const { lastIssueTypeLabel } = useIssueType();
  const orderNumber = useDisplayedOrderNumber();
  const { strictLocalize } = useStrictLocalization();

  if (lastIssueTypeLabel && orderNumber) {
    return strictLocalize(
      {
        defaultMessage:
          "{lastIssueTypeFullyTranslatedSentence} for order {orderNumber}",
        description: {
          text: "Text to inform the user of the topic they selected.",
        },
      },
      {
        lastIssueTypeFullyTranslatedSentence: lastIssueTypeLabel,
        orderNumber,
      }
    );
  } else if (lastIssueTypeLabel && !orderNumber) {
    return strictLocalize(
      {
        defaultMessage: "{lastIssueTypeFullyTranslatedSentence}",
        description: {
          text: "Text to inform the user of the topic they selected.",
        },
      },
      {
        lastIssueTypeFullyTranslatedSentence: lastIssueTypeLabel,
      }
    );
  }

  return "";
};
